module.exports = __webpack_public_path__ + "static/media/play_store.04da80ef.svg";